import { Injectable } from '@angular/core';
import { Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpService } from 'app/core/http/http.service';
import * as Models from 'app/core/models';
import { Languages } from 'app/core/models/shared.model';

@Injectable()
export class LookupService {

    constructor(private http: HttpService) {
    }

    getTags(isSystem?: boolean): Observable<Models.TagWithCount[]> {
        const myParams = new URLSearchParams();
        if(isSystem === true || isSystem === false){
            myParams.append('isSystem', isSystem.toString());
        }
        return this.http.get('lookup/tags', { params: myParams, cache: false })
            .map((res: Response) => res.json());
    }

    getCountries(): Observable<Models.Country[]> {
        return this.http.get('lookup/countries', { cache: false })
            .map((res: Response) => res.json());
    }

    getStepTypes(language: Languages): Observable<Models.StepType[]> {
        const myParams = new URLSearchParams();
        myParams.append('language', language.toString());

        return this.http.get('lookup/stepTypes', { params: myParams, cache: false })
            .map((res: Response) => res.json());
    }

    getStepTypePrefixes(language: Languages): Observable<Models.StepTypePrefix[]> {
        const myParams = new URLSearchParams();
        myParams.append('language', language.toString());

        return this.http.get('lookup/stepTypePrefixes', { params: myParams, cache: false })
            .map((res: Response) => res.json());
    }

    getTagCategories(): Observable<Array<Models.TagCategory>> {
        return this.http.get('lookup/tagCategories', { cache: false })
            .map((res: Response) => res.json());
    }

    getNewsFeedMessages(): Observable<Array<Models.NewsFeedMessage>> {
        return this.http.get('lookup/feedMessages', { cache: false })
            .map((res: Response) => res.json());
    }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/core/lookup/lookup.service.ts